import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  public breadcrumbs: any[] = [];

  constructor() { }

  public setBreadcrumbs(breadcrumbs: any[]): void {
    this.breadcrumbs = breadcrumbs;
    sessionStorage.setItem('breadcrumbs', JSON.stringify(breadcrumbs));
  }

  public getBreadcrumbs(): any[] {
    const breadcrumbs = JSON.parse(sessionStorage.getItem('breadcrumbs') || '[]');
    if (breadcrumbs.length !== 0) {
      this.breadcrumbs = breadcrumbs;
    }

    return this.breadcrumbs;
  }

  public clearBreadcrumbs(): void {
    this.breadcrumbs = [];
    sessionStorage.removeItem('breadcrumbs');
  }
}
